export function generateCompositeId(components: any): string {
  // return Buffer.from(JSON.stringify(components).normalize(), 'utf-8').toString(
  //   'base64',
  // );

  return btoa(
    String.fromCharCode.apply(
      null,
      new TextEncoder().encode(JSON.stringify(components).normalize()),
    ),
  );
}
